import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Home = () => {
	const navigate = useNavigate();
	const dataSummary = useSelector((state) => state.data.dataSummary);
	const operation = useSelector((state) => state.data.dataSummary[0]);

	useEffect(() => {
		if (dataSummary.length > 0) {
			navigate(`/operations/${operation.operationId}/${operation.stage}`);
		}
	}, [dataSummary]);

	return <></>;
};

export default Home;
